/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { FileUploadPage } from '../FileUploader/FileUpload'
import 'react-date-picker/dist/DatePicker.css'
import 'react-calendar/dist/Calendar.css'
// import SendAlertTo from '../Select/SendAlert'
import Comments from '../Comments/Comments'
import CustomDatePicker from '../CustomDatePicker'
import AssignTo from '../Select/AssignTo'
import SelectBoard from '../Select/SelectBoard'
import SelectColumn from '../Select/SelectColumn'
import clsx from 'clsx'
import { TextEditor } from '../TextEditor'
import CustomAlert from '../CustomAlert'
import Skeleton from 'react-loading-skeleton'
import React, { useRef, useEffect, useState } from 'react'
// import { useAuth } from '../../modules/auth'
import { useGetMember, useInputScrollToStart } from '../../hooks'
import { useCreateTaskFromChecklist } from '../../hooks/useCreateTaskFromChecklist'
import Remainder from '../Remainder'
import '../../styles/updateanaddform.css'
import { capitalizeEachWord, removeDuplication } from '../../helper-functions/CapitalizeName'
import { useTheme } from '../../context/ThemeContext'
import { defaultWhiteColor, priorityColors } from '../../utils/priorities'
import SelectTags from '../Select/SelectTags'
import SendEnvelopeModal from '../Modals/SendEnvelopeModal'
import { Dropdown, Spinner } from 'react-bootstrap'
import { downloadEnvelope, resendEnvelope, voidEnvelope } from '../../services/envelopes'
import VoidEnvelopeModal from '../Modals/VoidEnvelopeModal'
import ResendEnvelopeModal from '../Modals/ResendEnvelopeModal'
import ViewEnvelopeRecepient from '../Modals/ViewEnvelopeRecepient'
import ViewEnvelopeModal from '../Modals/ViewEnvelopeModal'
import FileIcon from '../GetUploadedFileIcons'
import { useAuth } from '../../modules/auth'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { formatDateAndTime   } from '../../helper-functions/TimeFormate'
import DueDateProgress from '../DueDateProgress'

const UpdateCardForm = ({
  formik,
  setCardLength,
  boardId,
  allBoardsVar,
  setBoardId,
  cardDetails,
  columns,
  columnId,
  setColumnId,
  isHomeSearching,
  deleteFileHandler,
  selectedFile,
  changeHandler,
  fileErrorMsg,
  setFileErrorMsg,
  sendAlertMsg,
  setSendAlertMsg,
  childCommentRef,
  optionsForSendAlert,
  setSendAlertToComment,
  sendAlertToComment,
  sendAlertToBoardPerson,
  boardPersonsForSendAlert,
  setEditorComment,
  editorComment,
  commentFileInfo,
  setCommentFileInfo,
  sendAlertMsgComment,
  // setCommentId,
  setStartDate,
  startDate,
  options,
  setSelected,
  selected,
  // disableBtn,
  editor,
  setEditor,
  checkIsDescriptionExist,
  reminders,
  setReminders,
  setDeletedReminderIds,
  isBoardLoading,
  isColumnLoading,
  isUserAssignLoading,
  setDesc,
  isCardDescriptionLoading, loading, tags, setSelectedTags, selectedTags, transformedTags,
  setMentions,
  retainMentions,
  uniqueId,
  sendAlertToMentionPerson,
  commentsLoading, setCommentsLoading, editorTags, setEditorTags, tocHeading, setTocHeading,
  envelopes,
  getCardHandler,
  cardLoading,
  isExpandedModal,
  expandedField,
  setExpandedField,
}: any) => {
  const getOptionColor = (value: string, theme: string) => {
    if (theme === 'dark') {
      return defaultWhiteColor
    } else {
      if (value) {
        return priorityColors[value]
      }
    }
  };
  //   const { currentUser } = useAuth()
  //   const { role : checkRole } = currentUser?.data.user
  const { theme } = useTheme()
  const { boardPerson } = useGetMember(boardId)
  const reminderMainRef: any = useRef<any>(null)
  const [reminderMainWidth, setReminderMainWidth] = useState(0)
  const [showTooltip, setShowTooltip] = useState(false)
  const [descHovered, setDescHovered] = useState(false)
  const [commentHovered, setCommentHovered] = useState(false)
  const titleInputRef = useInputScrollToStart<HTMLInputElement>();
  const [showEnvelopeModal, setShowEnvelopeModal] = useState(false);
  const [isLoading, setIsLoading] = useState<any>(null)
  const [isDownloading, setIsDownloading] = useState<any>(null)
  const [showVoidModal, setShowVoidModal] = useState<boolean>(false)
  const [showResendModal, setShowResendModal] = useState<boolean>(false)
  const [selectedEnvelope, setSelectedEnvelope] = useState<any>(null)
  const [successMessage, setSuccessMessage] = useState<string>('')
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [openViewEnvelope, setOpenViewEnvelope] = useState(false)
  const [openViewRecepeints, setOpenViewRecepeints] = useState(false)
  const { integrations } = useSelector((state: any) => state.integrationReducer)
  const isIntegrationAvailable = integrations?.map((integration: any) => integration?.name.toLowerCase()).includes('docusign') || false;
  const hasAccess = integrations?.find((integration: any) => integration?.name.toLowerCase() === 'docusign')?.hasAccess || false;
  const { currentUser } = useAuth();
  const id = currentUser?.data?.user?.id;
  const navigate = useNavigate();
  const cardId = cardDetails?.id;
  const formattedDate = cardDetails?.updatedAt ? formatDateAndTime(cardDetails.updatedAt) : ''
  const createTaskFromChecklist = useCreateTaskFromChecklist({ cardDetails })

  const inputStyle = {
    backgroundColor: theme === 'dark' ? '#2C3A4D' : '#ffffff',
    color: theme === 'dark' ? '#F4FFFD' : '#17181f',
    border: `1px solid ${theme === 'dark' ? 'hsl(0, 0%, 80%)' : '#ccc'}`,
    borderRadius: '4px',
    padding: '8px 12px',
    boxShadow: `0 0 0 1px ${theme === 'dark' ? '#333' : '#ccc'}`,
    outline: 'none',
    margin: '2px'
  }

  useEffect(() => {
    const updateWidth = () => {
      if (reminderMainRef.current) {
        setReminderMainWidth(reminderMainRef.current.offsetWidth)
      }
    }

    updateWidth()

    window.addEventListener('resize', updateWidth)

    return () => {
      window.removeEventListener('resize', updateWidth)
    }
  }, [])

  const resendEnvelopeHandler = async () => {
    setIsLoading(true)
    try {
      const res = await resendEnvelope(selectedEnvelope?.envelopeId)
      if (res.data.success) setSuccessMessage(res.data.message)
      setTimeout(() => {
        setShowResendModal(false)
      }, 3000);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.message)
    } finally {
      setTimeout(() => {
        setIsLoading(false)
        setSelectedEnvelope(null)
        setErrorMessage('')
        setSuccessMessage('')
      }, 3000);
    }
  }

  const voidEnvelopeHandler = async (reason: string) => {
    setIsLoading(true)
    try {
      const payload = { reason }
      const res = await voidEnvelope(selectedEnvelope?.envelopeId, payload)
      if (res.data.success) {
        setSuccessMessage(res.data.message)
      }
      setTimeout(() => {
        setShowVoidModal(false)
      }, 3000);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.message)
    } finally {
      setTimeout(() => {
        setIsLoading(false)
        setSelectedEnvelope(null)
        setErrorMessage('')
        setSuccessMessage('')
      }, 3000);
    }
  }

  const downloadEnvelopeHandler = async (envelope: any) => {
    setIsDownloading(envelope?.envelopeId)
    try {
      const response: any = await downloadEnvelope(envelope?.envelopeId)
      const blob = new Blob([response.data]);
      const contentDisposition = response.headers['content-disposition'];
      const filename = contentDisposition?.match(/filename="?(.+?)"?$/i)?.[1]
        || `${envelope?.documentName || 'document'}.pdf`;

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }, 100);

    } catch (error) {
      // console.error('Download failed:', error);
    } finally {
      setIsDownloading(null)
    }
  }

  const closeEnvelopeModal = () => {
    setShowEnvelopeModal(false);
  };

  const isSingleCommentExpanded = expandedField?.startsWith?.('comment-') ?? false
  const isDescriptionExpanded = expandedField === 'description'
  const isNewCommentExpanded = expandedField === 'newComment'

  // When description is in expanded view, show only the description section
  if (isDescriptionExpanded) {
    return (
      <div className='expanded-field-view'>
        <div className='expanded-field-header'>
          <div className='expanded-field-header-left'>
            <h6 className={`my-0 ${theme === 'dark' ? 'white__text' : 'text-dark'}`}>Description</h6>
            <div
              className="tooltip-container cursor-pointer"
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            >
              <i className={`bi bi-list bg-transparent fs-3 ${theme === 'dark' ? 'theme__div' : ''}`}></i>
              {showTooltip && editorTags?.length > 0 && <span className="tooltiptext">
                <div className='head fs-2 fw-bolder px-2 mb-2'>Contents of this task</div>
                {editorTags?.map((tag: any) => (
                  tag?.name?.length > 0 && (
                    <div
                      key={tag.name}
                      onClick={() => {
                        setTocHeading(tag);
                        setShowTooltip(false);
                      }}
                    >
                      <div className={`${tag?.tagName === 'h1' ? 'fs-4' : 'fs-4 ms-8'} cursor-pointer my-3 headings`}>
                        {tag.name}
                      </div>
                    </div>
                  )
                ))}
              </span>}
            </div>
          </div>
        </div>
        <div className='field-expandable' style={{ position: 'relative' }}>
          <button
            type='button'
            className={`field-expand-btn is-close-btn ${theme === 'dark' ? 'dark-btn' : ''}`}
            style={{ opacity: 1 }}
            onClick={() => setExpandedField(null)}
            title='Close expanded view'
          >
            <i className='bi bi-x-lg' style={{ fontSize: '1rem', color: theme === 'dark' ? '#ffffff' : '#212529' }}></i>
          </button>
          <TextEditor
            boardId={boardId}
            placeholder={''}
            handleFormSubmission={formik.handleSubmit}
            setEditor={setEditor}
            editor={editor}
            role={boardPerson?.role}
            forTitle='description'
            tabIndex={2}
            optionsForSendAlert={optionsForSendAlert}
            setDesc={setDesc}
            setMentions={setMentions}
            retainMentions={retainMentions}
            uniqueId={uniqueId}
            setEditorTags={setEditorTags}
            tocHeading={tocHeading}
            currentCardOrPage={cardDetails}
            isExpandedModal={isExpandedModal}
            enableChecklist
            onCreateTaskFromChecklistItem={createTaskFromChecklist}
          />
        </div>
      </div>
    )
  }

  // When a new comment is in expanded view, show only the new comment section
  if (isNewCommentExpanded) {
    return (
      <div className='expanded-field-view'>
        <div className='expanded-field-header'>
          <h6 className={`my-0 ${theme === 'dark' ? 'white__text' : 'text-dark'}`}>Comments</h6>
        </div>
        <Comments
          ref={childCommentRef}
          optionsForSendAlert={optionsForSendAlert}
          setSendAlertToComment={setSendAlertToComment}
          sendAlertToComment={sendAlertToComment}
          sendAlertToBoardPerson={sendAlertToBoardPerson}
          cardDetails={cardDetails}
          boardPersonsForSendAlert={boardPersonsForSendAlert}
          setEditorComment={setEditorComment}
          editorComment={editorComment}
          commentFileInfo={commentFileInfo}
          setCommentFileInfo={setCommentFileInfo}
          sendAlertMsgComment={sendAlertMsgComment}
          handleFormSubmission={formik.handleSubmit}
          role={boardPerson?.role}
          isUserAssignLoading={isUserAssignLoading}
          sendAlertToMentionPerson={sendAlertToMentionPerson}
          commentsLoading={commentsLoading}
          setCommentsLoading={setCommentsLoading}
          expandedField={expandedField}
          setExpandedField={setExpandedField}
          commentHovered={commentHovered}
          setCommentHovered={setCommentHovered}
          isCommentExpanded={false}
          skipReadComments={true}
        />
      </div>
    )
  }

  // When a single comment is in expanded view, show only the expanded comment section
  if (isSingleCommentExpanded) {
    return (
      <div className='expanded-field-view'>
        <Comments
          ref={childCommentRef}
          optionsForSendAlert={optionsForSendAlert}
          setSendAlertToComment={setSendAlertToComment}
          sendAlertToComment={sendAlertToComment}
          sendAlertToBoardPerson={sendAlertToBoardPerson}
          cardDetails={cardDetails}
          boardPersonsForSendAlert={boardPersonsForSendAlert}
          setEditorComment={setEditorComment}
          editorComment={editorComment}
          commentFileInfo={commentFileInfo}
          setCommentFileInfo={setCommentFileInfo}
          sendAlertMsgComment={sendAlertMsgComment}
          handleFormSubmission={formik.handleSubmit}
          role={boardPerson?.role}
          isUserAssignLoading={isUserAssignLoading}
          sendAlertToMentionPerson={sendAlertToMentionPerson}
          commentsLoading={commentsLoading}
          setCommentsLoading={setCommentsLoading}
          expandedField={expandedField}
          setExpandedField={setExpandedField}
          commentHovered={commentHovered}
          setCommentHovered={setCommentHovered}
          isCommentExpanded={true}
          skipReadComments={false}
        />
      </div>
    )
  }

  return (
    <form
      className='form row'
      onSubmit={(e) => {
        e.preventDefault()
        formik.handleSubmit()
      }}
      noValidate
    >
      <div className='col-md-12 col-lg-8 col-sm-12'>
        <div className='row mb-5'>
          <div className='col-md-12 col-lg-12 col-sm-12'>
            <label
              className={`form-label fs-6 fw-bolder ${theme === 'dark' ? 'white__text' : 'text-dark'
                }`}
            >
              Title
            </label>
            <input
              ref={titleInputRef}
              disabled={boardPerson?.role === 'Guest'}
              // placeholder='Email'
              {...formik.getFieldProps('cardName')}
              className={clsx(
                `form-control form-control-solid ${theme === 'dark' ? 'dark__theme__input' : ''}`,
                { 'is-invalid': formik.touched.cardName && formik.errors.cardName },
                {
                  'is-valid': formik.touched.cardName && !formik.errors.cardName,
                }
              )}
              type='name'
              name='cardName'
              autoComplete='off'
              maxLength={300}
              tabIndex={1}
              autoFocus
              placeholder=''
            />
            {formik.touched.cardName && formik.errors.cardName && (
              <div className='fv-plugins-message-container'>
                <span role='alert' className='text-danger'>
                  {formik.errors.cardName}
                </span>
              </div>
            )}
          </div>
        </div>
        {/* Description header */}
        <div className='d-flex align-items-center gap-1'>
          <h6 className={`my-3 ${theme === 'dark' ? 'white__text' : 'text-dark'}`}>Description</h6>
          <div
            className="tooltip-container cursor-pointer"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <i className={`bi bi-list bg-transparent fs-3 ${theme === 'dark' ? 'theme__div' : ''}`}></i>
            {showTooltip && editorTags?.length > 0 && <span className="tooltiptext">
              <div className='head fs-2 fw-bolder px-2 mb-2'>Contents of this task</div>
              {editorTags?.map((tag: any) => (
                tag?.name?.length > 0 && (
                  <div
                    key={tag.name}
                    onClick={() => {
                      setTocHeading(tag);
                      setShowTooltip(false);
                    }}
                  >
                    <div className={`${tag?.tagName === 'h1' ? 'fs-4' : 'fs-4 ms-8'} cursor-pointer my-3 headings`}>
                      {tag.name}
                    </div>
                  </div>
                )
              ))}
            </span>}
          </div>
        </div>

        {/* Description editor with expand button */}
        {(!isCardDescriptionLoading && !isUserAssignLoading ? (
          <>
            {checkIsDescriptionExist ? (
              <>
                {editor && editor.length > 0 && (
                  <div
                    className={`field-expandable ${descHovered ? '' : ''}`}
                    onMouseEnter={() => setDescHovered(true)}
                    onMouseLeave={() => setDescHovered(false)}
                    style={{ position: 'relative' }}
                  >
                    {setExpandedField && (
                      <button
                        type='button'
                        className={`field-expand-btn ${theme === 'dark' ? 'dark-btn' : ''}`}
                        onClick={() => setExpandedField('description')}
                        title='Expand field'
                      >
                        <i className='bi bi-arrows-fullscreen' style={{ fontSize: '1rem' }}></i>
                      </button>
                    )}
                    <TextEditor
                      boardId={boardId}
                      placeholder={''}
                      handleFormSubmission={formik.handleSubmit}
                      setEditor={setEditor}
                      editor={editor}
                      role={boardPerson?.role}
                      forTitle='description'
                      tabIndex={2}
                      optionsForSendAlert={optionsForSendAlert}
                      setDesc={setDesc}
                      setMentions={setMentions}
                      retainMentions={retainMentions}
                      uniqueId={uniqueId}
                      setEditorTags={setEditorTags}
                      tocHeading={tocHeading}
                      currentCardOrPage={cardDetails}
                      isExpandedModal={isExpandedModal}
                      enableChecklist
                      onCreateTaskFromChecklistItem={createTaskFromChecklist}
                    />
                  </div>
                )}
              </>
            ) : (
              <div
                className='field-expandable'
                onMouseEnter={() => setDescHovered(true)}
                onMouseLeave={() => setDescHovered(false)}
                style={{ position: 'relative' }}
              >
                {setExpandedField && (
                  <button
                    type='button'
                    className={`field-expand-btn ${theme === 'dark' ? 'dark-btn' : ''}`}
                    onClick={() => setExpandedField('description')}
                    title='Expand field'
                  >
                    <i className='bi bi-arrows-fullscreen' style={{ fontSize: '1rem' }}></i>
                  </button>
                )}
                <TextEditor
                  boardId={boardId}
                  role={boardPerson?.role}
                  placeholder={''}
                  handleFormSubmission={formik.handleSubmit}
                  setEditor={setEditor}
                  editor={editor}
                  forTitle='description'
                  tabIndex={2}
                  optionsForSendAlert={optionsForSendAlert}
                  setDesc={setDesc}
                  setMentions={setMentions}
                  retainMentions={retainMentions}
                  uniqueId={uniqueId}
                  setEditorTags={setEditorTags}
                  tocHeading={tocHeading}
                  currentCardOrPage={cardDetails}
                  isExpandedModal={isExpandedModal}
                  enableChecklist
                  onCreateTaskFromChecklistItem={createTaskFromChecklist}
                />
              </div>
            )}
          </>
        ) : (
          <React.Fragment>
            <Skeleton count={1} height={55} />
            <Skeleton count={1} height={170} />
          </React.Fragment>
        ))}

        {/* <h6 className={`my-3 ${theme === 'dark' ? 'white__text' : 'text-dark'}`}>Send Alert To:</h6> */}
        <div className='row my-2 d-flex'>
          <div className='col-md-9'>
            {/* {isUserAssignLoading  ? (
            <Skeleton count={1} height={40} />
          ):
           ( <SendAlertTo
              role={boardPerson?.role}
              options={optionsForSendAlert}
              setSelected={setSendAlertTo}
              selected={sendAlertTo}
            />)} */}
            <CustomAlert
              variant={'info'}
              className={'mt-2'}
              alertMessage={sendAlertMsg}
              setAlertMessage={setSendAlertMsg}
            />
          </div>
          <div className='col-md-3 col-sm-12 alert-btn py-4'>
            {/* <button
              disabled={boardPerson?.role === 'Guest'}
              className='btn btn-info px-2 pt-3 pb-2 '
              type='button'
              onClick={() =>
                sendAlertToBoardPerson(undefined, sendAlertTo, 'card-description', null)
              }
            >
              Send Alert
            </button> */}
          </div>
          <div className='col-md-9'>
            {/* <CustomAlert
              variant={'info'}
              className={'mt-2'}
              alertMessage={sendAlertMsg}
              setAlertMessage={setSendAlertMsg}
            /> */}
          </div>
        </div>

        <FileUploadPage
          deleteFileHandler={deleteFileHandler}
          selectedFile={selectedFile}
          changeHandler={changeHandler}
        />
        <CustomAlert
          variant={'warning'}
          className={'mt-2'}
          alertMessage={fileErrorMsg}
          setAlertMessage={setFileErrorMsg}
          time={5000}
        />

        {/* Show DocuSign section only when integration is available OR envelopes exist */}
        {((isIntegrationAvailable && hasAccess) || (envelopes && envelopes.length > 0)) && (
        <>
        <hr />
        <div className='row mt-3 mb-5 me-1 border'>
          <div className='col-md-12'>
            <div className={`card ${theme === 'dark' ? 'theme__div' : 'bg-white'}`}>
              <div className='card-header border-0  px-0'>
                <h3 className={`card-title align-items-start flex-column ${theme === 'dark' ? 'white__text' : 'text-dark'}`}>
                  <span className={`card-label fw-bold fs-3 ${theme === 'dark' ? 'text-white' : ''}`}>DocuSign Envelope</span>
                </h3>
                {envelopes && envelopes?.length > 0 && (
                  <div className='card-toolbar gap-2'>
                    {(isIntegrationAvailable && hasAccess) ?
                      <>
                        <button
                          type='button'
                          className='btn btn-icon btn-light btn-sm'
                          onClick={() => {
                            getCardHandler(cardId)
                          }}
                          title="Reload Envelopes"
                        >
                          <i className="bi bi-arrow-clockwise fs-4"></i>
                        </button>
                        <button
                          type='button'
                          className='btn btn-sm btn-primary'
                          onClick={() => setShowEnvelopeModal(true)}
                        >
                          <i className='bi bi-envelope me-2'></i>
                          Send New Envelope
                        </button></> :
                     (!boardPerson?.role || boardPerson?.role !== 'Guest') ? <button
                        type='button'
                        className='btn btn-icon btn-light btn-sm btn-primary w-100 px-2'
                        onClick={() => navigate('/integrations')}
                      >
                        Add Integration
                      </button>:<></>
                    }
                  </div>)}
              </div>
              <div className='card-body px-0 py-1'>
                <div className='table-responsive'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead>
                      <tr className='fw-bolder text-muted'>
                        <th className='min-w-200px'>File Name</th>
                        <th className='min-w-100px'>Subject</th>
                        <th className='min-w-80px'>Sent to</th>
                        <th className='min-w-80px'>Status</th>
                        <th className='min-w-100px'>Last Updated</th>
                        {isIntegrationAvailable && hasAccess && (
                          <>
                            <th className='w-10px'></th>
                            <th className='min-w-100px d-flex justify-content-end pe-5 border-0'>Action</th>
                          </>
                        )}
                      </tr>
                    </thead>
                    {cardLoading && (
                      <tbody>
                        {Array.from({ length: 3 }, (_, key) => (
                          <tr key={key} className='my-2'>
                            <td>
                              <Skeleton count={1} height={25} />
                            </td>
                            <td>
                              <Skeleton count={1} height={25} />
                            </td>
                            <td>
                              <Skeleton count={1} height={25} />
                            </td>
                            <td>
                              <Skeleton count={1} height={25} />
                            </td>
                            <td>
                              <Skeleton count={1} height={25} />
                            </td>
                            <td>
                              <Skeleton count={1} height={25} />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                    <tbody>
                      {!cardLoading &&
                        <>
                          {envelopes && envelopes?.length > 0 ? envelopes?.map((file: any, index: any) => {
                            const lastUpdate = formatDateAndTime(file?.updatedAt);
                            return (
                              <tr key={index}>
                                <td>
                                  <div className='d-flex align-items-center'>
                                    <div className='symbol symbol-45px me-2'>
                                      <FileIcon fileName={file?.documentName} showName={file?.documentName} />
                                    </div>
                                    <div className='d-flex justify-content-start flex-column'>
                                      <span className={`${theme === 'dark' ? 'white__text' : 'text-dark'} fw-bold fs-6`}>
                                        {file?.documentName?.toLowerCase() || file?.showName?.toLowerCase()}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td>{file?.subject || '-'}</td>
                                <td className={`${(file?.requesterId === id) ? 'cursor-pointer text-decoration-underline text-primary' : ''}`} onClick={
                                  () => {
                                    if (file?.requesterId !== id) return;
                                    setOpenViewRecepeints(true)
                                    setSelectedEnvelope(file);
                                  }
                                }>
                                  {(file?.requesterId === id) ? file?.signerEmails?.length : '-'}</td>
                                <td>{capitalizeEachWord(file?.status)}</td>
                                <td>{lastUpdate}</td>
                                {isIntegrationAvailable && hasAccess && (<>
                                  <td>
                                    {file?.id === isDownloading ?
                                      <> <Spinner animation='border' variant='primary' /></>
                                      :
                                      (<span className="cursor-pointer" onClick={() => downloadEnvelopeHandler(file)}>
                                        <i className={`bi bi-download fs-3 ${theme === 'dark' ? 'text-white' : ''}`} ></i>
                                      </span>)

                                    }
                                  </td>
                                  <td className='justify-content-end px-5 d-flex pe-5 border-0'>
                                    <Dropdown>
                                      <Dropdown.Toggle size='sm' variant='secondary' id='dropdown-basic'>
                                        <i className='bi bi-three-dots'></i>
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu className={theme === 'dark' ? 'theme__div position-fixed' : 'position-fixed'}>
                                        <Dropdown.Item
                                          className={theme === 'dark' ? 'text-muted' : 'text-dark'}
                                          onClick={() => {
                                            setOpenViewEnvelope(true)
                                            setSelectedEnvelope(file);
                                          }}
                                        >
                                          View Document
                                        </Dropdown.Item>
                                        {((file?.requesterId === id) && !['completed', 'voided', 'deleted', 'timeout'].includes(file?.status)) && (
                                          <Dropdown.Item
                                            className={theme === 'dark' ? 'text-muted' : 'text-dark'}
                                            onClick={() => {
                                              setShowVoidModal(true);
                                              setSelectedEnvelope(file);
                                            }}
                                          >
                                            Void Document
                                          </Dropdown.Item>
                                        )}
                                        {((file?.requesterId === id) && ['sent', 'delivered', 'declined'].includes(file?.status)) && (
                                          <Dropdown.Item
                                            className='text-primary'
                                            onClick={() => {
                                              setShowResendModal(true)
                                              setSelectedEnvelope(file)
                                            }}
                                          >
                                            Resend Document
                                          </Dropdown.Item>
                                        )}
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>
                                </>)}
                              </tr>
                            );
                          }) :
                            <tr>
                              <td colSpan={5} className='text-center py-5'>
                                <div className='d-flex flex-column align-items-center'>
                                  <i className='bi bi-inbox fs-2x text-muted mb-3'></i>
                                  <span className={`${theme === 'dark' ? 'text-muted' : 'text-muted'} fs-6`}>
                                    {(isIntegrationAvailable && hasAccess) ?
                                      'No attachments added yet. Click "Send Envelope" to add documents.' :
                                      'No DocuSign integration found. Please add the integration to send envelopes.'}
                                  </span>
                                  {(isIntegrationAvailable && hasAccess) ?
                                    <button
                                      type='button'
                                      className='btn btn-sm btn-primary mt-3'
                                      onClick={() => setShowEnvelopeModal(true)}
                                    >
                                      <i className='bi bi-plus-circle me-2'></i>
                                      Send Envelope
                                    </button> :
                                   (!boardPerson?.role || boardPerson?.role !== 'Guest' )? <button
                                      type='button'
                                      className='btn btn-icon btn-light btn-sm btn-primary w-200px px-2'
                                      onClick={() => navigate('/integrations')}
                                    >
                                      Add Integration
                                    </button> :<></>
                                  }
                                </div>
                              </td>
                            </tr>
                          }
                        </>}

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        </>
        )}

        <div className='my-10 comments-section-small-scr'>
          <h6 className={`my-3 mt-5 ${theme === 'dark' ? 'white__text' : 'text-dark'}`}>
            Comments
          </h6>
          <Comments
            ref={childCommentRef}
            optionsForSendAlert={optionsForSendAlert}
            setSendAlertToComment={setSendAlertToComment}
            sendAlertToComment={sendAlertToComment}
            sendAlertToBoardPerson={sendAlertToBoardPerson}
            cardDetails={cardDetails}
            boardPersonsForSendAlert={boardPersonsForSendAlert}
            setEditorComment={setEditorComment}
            editorComment={editorComment}
            commentFileInfo={commentFileInfo}
            setCommentFileInfo={setCommentFileInfo}
            sendAlertMsgComment={sendAlertMsgComment}
            handleFormSubmission={formik.handleSubmit}
            role={boardPerson?.role}
            isUserAssignLoading={isUserAssignLoading}
            sendAlertToMentionPerson={sendAlertToMentionPerson}
            commentsLoading={commentsLoading}
            setCommentsLoading={setCommentsLoading}
            expandedField={expandedField}
            setExpandedField={setExpandedField}
            commentHovered={commentHovered}
            setCommentHovered={setCommentHovered}
          />
        </div>
      </div>
      <div className='col-md-12 col-lg-4 col-sm-12 border px-2 py-2'>
        <h4 className={`text-center ${theme === 'dark' ? 'white__text' : 'text-dark'}`}>Details</h4>

        <div className='row mb-5'>
          <div className='col-12 my-3'>
            <h6 className={theme === 'dark' ? 'white__text' : 'text-dark'}>Assigned to</h6>
            {isUserAssignLoading ? (
              <Skeleton count={1} height={97} />
            ) : (
              <AssignTo
                page={false}
                options={options}
                role={boardPerson?.role}
                setSelected={setSelected}
                selected={removeDuplication(selected)}
              />)}
          </div>
          <div className='col-12 my-2'>
            <label
              className={`${theme === 'dark' ? 'white__text' : 'text-dark'
                } form-label fs-6 fw-bolder `}
            >
              Board
            </label>
            {isBoardLoading ? (
              <Skeleton count={1} height={40} />
            ) : (
              <SelectBoard
                role={boardPerson?.role}
                setCardLength={setCardLength}
                boardId={boardId}
                cardDetails={cardDetails || undefined}
                boards={allBoardsVar}
                setBoardId={setBoardId}
                boardIdFromCardDetails={cardDetails?.boardId}
                boardName={cardDetails?.board_name}
              />
            )}
          </div>

          <div className='col-12 my-2'>
            <label
              className={`${theme === 'dark' ? 'white__text' : 'text-dark'
                } form-label fs-6 fw-bolder `}
            >
              Column
            </label>
            {isColumnLoading ? (
              <Skeleton count={1} height={40} />
            ) : (
              <SelectColumn
                role={boardPerson?.role}
                boardId={boardId}
                cardDetails={cardDetails || undefined}
                columns={columns}
                columnId={columnId}
                setColumnId={setColumnId}
              />)}
          </div>
        </div>
        <div className={isHomeSearching ? ' my-2' : `fv-row mb-3 col-12 my-2`}>
          <label
            className={`form-label fs-6 fw-bolder  ${theme === 'dark' ? 'white__text' : 'text-dark'
              }`}
          >
            Due date & time
          </label>
           {startDate && cardDetails?.createdAt && (
              <DueDateProgress
                createdAt={cardDetails.createdAt}
                dueDate={startDate instanceof Date ? startDate.toISOString() : startDate}
                status={formik.values.status}
                theme={theme}
              />
            )}
          <div className="due-date-row">
            <div className={`due-date-row__picker ${theme === 'dark' ? 'react_date_dark' : ''}`}>
              <CustomDatePicker
                role={boardPerson?.role}
                cardDetails={cardDetails}
                setStartDate={setStartDate}
                startDate={startDate}
                isPlaceholder={true}
                className={isHomeSearching ? 'w-100' : ''}
              />
            </div>
          </div>
           
        </div>
        <div
          ref={reminderMainRef}
          className='fv-row mb-3 my-2 d-flex justify-content-between align-items-center'
        >
          <label
            className={`form-label fs-6 fw-bolder  ${theme === 'dark' ? 'white__text' : 'text-dark'
              }`}
          >
            Reminder
          </label>
          <div className='d-flex justify-content-end' style={{ width: '100%' }}>
            <Remainder
              cardDetails={cardDetails}
              reminders={reminders}
              setReminders={setReminders}
              isDisable={startDate}
              setDeletedReminderIds={setDeletedReminderIds}
              parentWidth={reminderMainWidth}
            />
          </div>
        </div>

        <div className='mb-3 row'>
          <label
            className={`col-sm-4 col-form-label ${theme === 'dark' ? 'white__text' : 'text-dark'}`}
          >
            Status
          </label>
          <div className='col-sm-8'>
            <select
              disabled={boardPerson?.role === 'Guest'}
              {...formik.getFieldProps('status')}
              className={clsx(
                `form-control form-control-lg form-control-solid  ${theme === 'dark' ? 'dark__theme__input' : ''}`,
                { 'is-invalid': formik.touched.status && formik.errors.status },
                {
                  'is-valid': formik.touched.status && !formik.errors.status,
                }
              )}
            >
              <option value='' disabled>
                Select
              </option>
              <option value='todo'>To Do</option>
              <option value='in-progress'>In Progress</option>
              <option value='done'>Done</option>
              <option value='archived'>Archived</option>
            </select>
            {formik.touched.status && formik.errors.status && (
              <div className='fv-plugins-message-container'>
                <span role='alert' className='text-danger'>
                  {formik.errors.status}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className='mb-3 row'>
          <label
            className={`col-sm-4 col-form-label ${theme === 'dark' ? 'white__text' : 'text-dark'}`}
          >
            Priority
          </label>
          <div className='col-sm-8'>
            <select
              disabled={boardPerson?.role === 'Guest'}
              {...formik.getFieldProps('priority')}
              className={clsx(
                `form-control form-control-lg form-control-solid  ${theme === 'dark' ? 'dark__theme__input__no__color' : ''} `,
                { 'is-invalid': formik.touched.priority && formik.errors.priority },
                {
                  'is-valid': formik.touched.priority && !formik.errors.priority,
                }
              )}
              style={{ color: getOptionColor(formik.values.priority, theme) }}
            >
              <option className={theme === 'dark' ? 'label-color' : ''} value={undefined}>Set priority</option>
              {['Critical', 'High', 'Medium', 'Low', 'Future'].map((option, index) => (
                <option key={index} value={option} style={{ color: getOptionColor(option, theme) }}>
                  {option}
                </option>
              ))}
            </select>
            {formik.touched.priority && formik.errors.priority && (
              <div className='fv-plugins-message-container'>
                <span role='alert' className='text-danger'>
                  {formik.errors.priority}
                </span>
              </div>
            )}
          </div>
        </div>

        <div className='mb-3'>
          <label
            className={`col-form-label ${theme === 'dark' ? 'white__text' : 'text-dark'}`}
          >
            Tags
          </label>
          <div className=''>
            {loading ? (
              <Skeleton count={1} height={40} />
            ) : (
              <SelectTags role={boardPerson?.role} tags={tags} transformedTags={transformedTags} setSelectedTags={setSelectedTags} selectedTags={selectedTags} boardId={boardId} />
            )}
          </div>
        </div>
        <div className='col-12 my-3'>
          <h6 className={theme === 'dark' ? 'white__text' : ''}>Date last updated</h6>
          <input
            type='text'
            disabled
            className='form-control w-100'
            placeholder='dd-mm-yyy'
            style={inputStyle}
            value={formattedDate}
          />
        </div>
      </div>
      {/* <div className="row d-flex flex-lg-row flex-column-reverse">
        <div className='my-5 col-md-12 col-lg-8 col-sm-12 comments-section-small-scr'>
          <h6 className={`my-3 mt-5 ${theme === 'dark' ? 'white__text' : 'text-dark'}`}>
            Comments
          </h6>
          <Comments
            ref={childCommentRef}
            optionsForSendAlert={optionsForSendAlert}
            setSendAlertToComment={setSendAlertToComment}
            sendAlertToComment={sendAlertToComment}
            sendAlertToBoardPerson={sendAlertToBoardPerson}
            cardDetails={cardDetails}
            boardPersonsForSendAlert={boardPersonsForSendAlert}
            setEditorComment={setEditorComment}
            editorComment={editorComment}
            sendAlertMsgComment={sendAlertMsgComment}
            handleFormSubmission={formik.handleSubmit}
            role={boardPerson?.role}
          />
        </div>
      </div> */}

      {/* <div className='row d-flex justify-content-between mt-4 mb-10'>
                <div className='col-md-6 col-lg-6 col-sm-12'>
                    <h6>
                        Assigned to{' '}
                        <AssignTo options={options} setSelected={setSelected} selected={selected} />
                    </h6>
                </div> */}
      {/* <div className='col-md-4 col-lg-4 col-sm-12'>
                    <div className='d-flex justify-content-end mt-6'>
                        <Button
                            disabled={(boardId.length > 0 && columnId) || disableBtn ? false : true}
                            className={`${disableBtn && 'btn-custom-secondary'} w-75`}
                            type='submit'
                        >
                            {disableBtn ? <Spinner animation='border' variant='light' /> : 'Save'}
                        </Button>
                    </div>
                </div> */}
      {/* </div> */}

      {/* Send Envelope Modal */}
      <SendEnvelopeModal
        showModal={showEnvelopeModal}
        closeModal={closeEnvelopeModal}
        // assignees={options}
        cardId={cardId}
        refetchCardEnvelopes={getCardHandler}
      />

      {openViewEnvelope && (
        <ViewEnvelopeModal showModal={openViewEnvelope} closeModal={() => {
          setOpenViewEnvelope(false)
        }}
          envelopeId={selectedEnvelope?.envelopeId}
          isSender={selectedEnvelope?.requesterId === id}
          status={selectedEnvelope?.status}
        />
      )}
      {openViewRecepeints && (
        <ViewEnvelopeRecepient showModal={openViewRecepeints} closeModal={() => {
          setOpenViewRecepeints(false)
          setSelectedEnvelope(null)
        }}
          envelope={selectedEnvelope}
        />
      )}
      {showResendModal && (
        <ResendEnvelopeModal showModal={showResendModal} closeModal={() => {
          setShowResendModal(false)
          setSelectedEnvelope(null)
        }}
          onResendHandler={resendEnvelopeHandler}
          envelope={selectedEnvelope}
          message={successMessage}
          errorMessage={errorMessage}
          loading={isLoading}
        />
      )}
      {showVoidModal && (
        <VoidEnvelopeModal showModal={showVoidModal} closeModal={() => {
          setShowVoidModal(false)
          setSelectedEnvelope(null)
        }}
          onVoidHandler={voidEnvelopeHandler}
          envelope={selectedEnvelope}
          errorMessage={errorMessage}
          message={successMessage}
          loading={isLoading}
        />
      )}
    </form>
  )
}

export default UpdateCardForm
